import { httpCreate } from './http';

const http = httpCreate('/srv/alipay');

export const alipay = {
	//绑定支付宝链接
	getAlipay(params) {
		return http.get('/authUrl', { params });
	},
	//解绑
	unBound(params) {
		return http.post('/unBound', null, {params,headers: {
			'Content-Type': 'application/json'
		},})
	}
};
